"use client";

import { Pill } from "@/components/ui/pill";

// The member/role status chip is the shared `Pill`. Re-exported under the
// historical `Badge` name so the existing settings call sites stay untouched.
export { Pill as Badge };

export function RoleBadge({ role }: { role: string }) {
  if (role === "admin") {
    return (
      <Pill
        bg="bg-[rgba(255,58,100,0.1)]"
        border="border-[rgba(255,141,165,0.1)]"
        text="text-[#be185d] dark:text-[#ff8da5]"
      >
        Admin
      </Pill>
    );
  }
  return (
    <Pill bg="bg-contrast/10" border="border-border" text="text-contrast/75">
      Member
    </Pill>
  );
}
